import { SalesOrderContractTask } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';

/**
 * 1640. 受注案件契約タスク編集
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/sales_order_contract_task_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
  contract_context_id: number;
  name: string;
  description?: string;
  due_date?: string;
  user_id: number;
};

const updateSalesOrderContractTask = (props: Props): Promise<SalesOrderContractTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks/${props.id}`,
    props
  );
};

export const useUpdateSalesOrderContractTask = () => {
  return useMutation({
    mutationFn: updateSalesOrderContractTask,
  });
};
